import React from "react";

// Herbruikbare form-primitives in huisstijl (geen shadcn-wrap nodig; matcht directory filters)

const inputBase =
  "w-full bg-white border border-[#E4EEF5] rounded-xl px-4 py-2.5 font-[Inter] text-[15px] text-[#173A5E] placeholder:text-[#8AA3B8] outline-none focus:border-[#2E9CD6] focus:ring-2 focus:ring-[#6BC0E8]/40 transition disabled:bg-[#F4F8FB] disabled:cursor-not-allowed";

export const Label = ({ children, htmlFor, required = false }) => (
  <label
    htmlFor={htmlFor}
    className="block text-sm font-[Poppins] font-semibold text-[#173A5E] mb-1.5"
  >
    {children}
    {required && <span className="text-[#CE1B2A] ml-0.5">*</span>}
  </label>
);

export const FieldError = ({ children }) =>
  children ? (
    <p className="mt-1 text-xs font-[Inter] text-[#CE1B2A]">{children}</p>
  ) : null;

export const TextField = ({
  id,
  label,
  required = false,
  error,
  type = "text",
  ...rest
}) => (
  <div>
    {label && (
      <Label htmlFor={id} required={required}>
        {label}
      </Label>
    )}
    <input
      id={id}
      type={type}
      data-testid={`field-${id}`}
      className={`${inputBase} ${error ? "border-[#CE1B2A]" : ""}`}
      {...rest}
    />
    <FieldError>{error}</FieldError>
  </div>
);

export const TextArea = ({ id, label, required = false, error, ...rest }) => (
  <div>
    {label && (
      <Label htmlFor={id} required={required}>
        {label}
      </Label>
    )}
    <textarea
      id={id}
      data-testid={`field-${id}`}
      className={`${inputBase} min-h-[100px] resize-y ${
        error ? "border-[#CE1B2A]" : ""
      }`}
      {...rest}
    />
    <FieldError>{error}</FieldError>
  </div>
);

export const SelectField = ({
  id,
  label,
  required = false,
  options,
  error,
  placeholder = "Kies…",
  ...rest
}) => (
  <div>
    {label && (
      <Label htmlFor={id} required={required}>
        {label}
      </Label>
    )}
    <select
      id={id}
      data-testid={`field-${id}`}
      className={`${inputBase} appearance-none ${
        error ? "border-[#CE1B2A]" : ""
      }`}
      {...rest}
    >
      <option value="">{placeholder}</option>
      {options.map((o) => (
        <option key={o.value} value={o.value}>
          {o.label}
        </option>
      ))}
    </select>
    <FieldError>{error}</FieldError>
  </div>
);

export const RadioGroup = ({ id, label, required, options, value, onChange, error }) => (
  <div>
    {label && <Label required={required}>{label}</Label>}
    <div className="flex flex-col sm:flex-row gap-3">
      {options.map((o) => (
        <label
          key={o.value}
          data-testid={`radio-${id}-${o.value}`}
          className={`flex items-center gap-2 px-4 py-2.5 rounded-xl border cursor-pointer font-[Inter] text-sm transition ${
            value === o.value
              ? "border-[#2E9CD6] bg-[#F4F8FB] text-[#173A5E]"
              : "border-[#E4EEF5] text-[#3E5871] hover:border-[#6BC0E8]"
          }`}
        >
          <input
            type="radio"
            name={id}
            value={o.value}
            checked={value === o.value}
            onChange={(e) => onChange(e.target.value)}
            className="accent-[#2E9CD6]"
          />
          <span>{o.label}</span>
        </label>
      ))}
    </div>
    <FieldError>{error}</FieldError>
  </div>
);
